export default __webpack_public_path__ + "static/media/IconDesc_HyperTube_WallHole.256.f0a69bf5.png";